import { z } from 'zod';

import type { TFunction } from 'i18next';

import { stripHtml } from '@/helpers';

const isRichTextFilled = (value: string) => stripHtml(value).trim().length > 0;

export function createBookingEmailTemplateSchema(t: TFunction) {
  return z
    .object({
      subject: z.string(),
      body: z.string(),
      confirmation_text: z.string(),
      active: z.boolean(),
    })
    .superRefine((values, ctx) => {
      if (!values.active) {
        return;
      }

      if (!values.subject.trim()) {
        ctx.addIssue({
          code: 'custom',
          path: ['subject'],
          message: t('validation_required'),
        });
      }

      if (!isRichTextFilled(values.body)) {
        ctx.addIssue({
          code: 'custom',
          path: ['body'],
          message: t('validation_required'),
        });
      }
    });
}

export type BookingEmailTemplateValues = z.infer<
  ReturnType<typeof createBookingEmailTemplateSchema>
>;

export function createBookingTestEmailSchema(t: TFunction) {
  return z.object({
    service_id: z.string().min(1, { message: t('validation_required') }),
    location_id: z.string().min(1, { message: t('validation_required') }),
    first_name: z
      .string()
      .trim()
      .min(1, { message: t('validation_required') }),
    email: z
      .string()
      .min(1, { message: t('validation_required') })
      .email({ message: t('validation_email') }),
  });
}

export type BookingTestEmailValues = z.infer<
  ReturnType<typeof createBookingTestEmailSchema>
>;
